import { makeStyles } from '@mui/styles';

const useStaticContentFiltersFormStyle = makeStyles({
  container: {
    width: '100%',
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default useStaticContentFiltersFormStyle;
